'use client';

import { pushObjectView } from '@/lib/analytics';
import { FC, useEffect } from 'react';

import { getObjectViewSource } from '../utils/getObjectViewSource';

type ObjectViewTrackerProps = {
  objectId: string;
  isProject?: boolean;
};

/** Fires `object_view` once per object id after mount. */
export const ObjectViewTracker: FC<ObjectViewTrackerProps> = ({ objectId, isProject = false }) => {
  useEffect(() => {
    pushObjectView(objectId, getObjectViewSource(objectId), isProject);
  }, [objectId, isProject]);

  return null;
};
